import Client from './Client';

export enum StatusEnum {
  API_DEV_CONFIGURED = 'API-DEV-CONFIGURED',
  BILLING = 'BILLING',
  CLONED = 'CLONED',
  DEV_CONFIGURED = 'DEV-CONFIGURED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SETUP = 'SETUP',
}

class SetupStatus {
  set fromJson(data: Map<string, any>) {
    this.id = data['id'];
    this.error = data['error'];
    this.createdAt = new Date(Date.parse(data['createdAt']));
    this.status = data['status'];
    this.step = data['step'];
    this.client =
      data['client'] !== undefined && data['client'] !== null
        ? (new Client().fromJson = data['client'])
        : '';
  }

  get toJson() {
    return {
      id: this.id,
      error: this.error,
      createdAt: this.createdAt?.toString(),
      status: this.status,
      step: this.step,
      client: this.client?.toJson,
    };
  }

  public id: number | undefined;
  public error: string | undefined;
  public createdAt: Date | undefined;
  public status: string | undefined;
  public step: number | undefined;
  public client: Client | undefined;
}

export default SetupStatus;
